import { render } from "./RtpiDeparturesList.vue?vue&type=template&id=4aa15f96&scoped=true&lang=pug"
import script from "./RtpiDeparturesList.vue?vue&type=script&lang=ts"
export * from "./RtpiDeparturesList.vue?vue&type=script&lang=ts"

import "./RtpiDeparturesList.vue?vue&type=style&index=0&id=4aa15f96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4aa15f96"

export default script